import { FactoryVerificationStep } from '@/types/LocationVerification.type';

export function shouldAdvanceToRoomOnSave(params: {
  step: FactoryVerificationStep;
  hasEntrancePhoto: boolean;
  isEntranceProgressCommitted: boolean;
}): boolean {
  const { step, hasEntrancePhoto, isEntranceProgressCommitted } = params;
  return (
    (step === 'entrance' && hasEntrancePhoto) || (step === 'saved' && isEntranceProgressCommitted)
  );
}

export function shouldShowRoomStepBackButton(
  step: FactoryVerificationStep,
  stepParam?: string
): boolean {
  return step === 'room' || stepParam === 'room';
}

export function shouldShowVerificationMap(
  step: FactoryVerificationStep,
  isInitialGpsPending: boolean,
  hasDeviceLocation: boolean
): boolean {
  if (isInitialGpsPending || !hasDeviceLocation) {
    return false;
  }
  return step === 'entrance' || step === 'saved' || step === 'room';
}

export function shouldShowVerificationMapPlaceholder(
  step: FactoryVerificationStep,
  isInitialGpsPending: boolean,
  hasDeviceLocation: boolean
): boolean {
  if (isInitialGpsPending || hasDeviceLocation) {
    return false;
  }
  return step === 'entrance' || step === 'saved' || step === 'room';
}
